<template lang="pug">
div
  div.fullwidth
      div.title-container
          h1.product-title {{ title }}
      h2.product-subtitle Latest
      div.margin-bottom
          .manual-download
              .factsandbluebox
                  .bluebox(v-for="(manual, index) in manuals" :key="index")
                      .manual-info
                          Downloadlink(:text="manual.text", :link="manual.link")
                          div(v-if="manual.releaseDate")#info Release Date: {{ manual.date }}
                          div(v-if="manual.softwareVersions")#info Software-Versions {{ manual.softwareVersions }}
      div(v-if="archiveFiles.length > 0")
        h2.product-subtitle Archive
        div.margin-bottom
            .manual-download
                .factsandbluebox
                    .bluebox(v-for="(manual, index) in archiveFiles" :key="index")
                        .manual-info
                            Downloadlink(:text="manual.text", :link="manual.link")
                            div(v-if="manual.releaseDate")#info Release Date: {{ manual.date }}
                            div(v-if="manual.softwareVersions")#info Software-Versions {{ manual.softwareVersions }}
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    manuals: {
      type: Array,
      required: true
    },
    archiveFiles: {
      type: Array,
      required: false
    },
  },
  metaInfo: {
    meta: [
      { name: 'robots', content: 'noindex, nofollow' }
    ]
  },
}
</script>

<style lang='sass' scoped>
.manual-info
    display: flex
    #info
        height: 100%
        margin: auto
        padding-bottom: 10px
        flex: 0.5
        font-weight: 300
        font-size: small
        text-align: end

h2.product-subtitle
    font-size: 1.5em
    font-weight: 300
    color: #555
    margin-bottom: 20px
    margin-top: 0
</style>

   